import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import * as Auth from 'auth/components';

import { recoverPassword } from 'auth/actions';
import { addSingleInlineMessage, clearInlineMessages } from 'messages/actions';

class RecoverPasswordContainer extends Component {
  state = {
    values: { email: '' },
    isValid: false,
    isSubmitted: false,
    isLoading: false,
  };

  componentWillMount = () => {
    this.props.clearInlineMessages();
  };

  handleValueChange = (e, field) => {
    this.setState({
      values: {
        ...this.state.values,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = ({ isValid }, data) => {
    this.setState(
      { isSubmitted: true },
      () =>
        isValid &&
        this.props
          .recoverPassword(this.state.values.email)
          .then((result) => {
            this.props.history.push('/auth/login');
            this.props.addMessage(result.value.message, 'success');
          })
          .catch((err) => this.props.addMessage(err.message, 'danger'))
    );
  };

  handleValidation = (isValid, message) => {
    this.setState({ isValid }, () => {
      this.props.clearInlineMessages();
      if (!this.state.isValid && this.state.isSubmitted) {
        this.props.addMessage(message, 'danger');
      }
    });
  };

  render = () => (
    <Auth.RecoverPasswordView
      handleSubmit={this.handleSubmit}
      handleValidation={this.handleValidation}
      handleValueChange={this.handleValueChange}
      isLoading={this.props.isLoading}
      isSubmitted={this.state.isSubmitted}
      values={this.state.values}
    />
  );
}

RecoverPasswordContainer.propTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.auth.isLoading,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  recoverPassword: (email) => dispatch(recoverPassword(email)),
  addMessage: (text, type) => dispatch(addSingleInlineMessage(text, type)),
  clearInlineMessages: () => dispatch(clearInlineMessages()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  translate()
)(RecoverPasswordContainer);



// WEBPACK FOOTER //
// src/modules/auth/containers/RecoverPasswordContainer.js